import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/report/mytax';

const exportBatchSubmissionTemplate = (merchantId, branchId, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/${branchId}/batch-submission/export/list`,
		payload,
		{
			responseType: 'blob',
			timeout: 60000,
		}
	);
};

const exportSqlAccArIv = (merchantId, branchId, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/${branchId}/batch-submission/export/sql-ar-iv`,
		payload,
		{
			responseType: 'blob',
			timeout: 60000,
		}
	);
};

const getSupplierProfile = (merchantId, branchId) => {
	return Client.get(`${baseUrl}/${merchantId}/${branchId}/supplier-profile`);
};

const setSupplierProfile = (merchantId, branchId, payload) => {
	return Client.post(
		`${baseUrl}/${merchantId}/${branchId}/supplier-profile`,
		payload
	);
};

const getApiCredential = (merchantId, branchId) => {
	return Client.get(`${baseUrl}/${merchantId}/${branchId}/api-credential`);
};

const setApiCredential = (merchantId, branchId, payload) => {
	return Client.post(
		`${baseUrl}/${merchantId}/${branchId}/api-credential`,
		payload
	);
};

export default {
	exportBatchSubmissionTemplate,
	exportSqlAccArIv,
	getSupplierProfile,
	setSupplierProfile,
	getApiCredential,
	setApiCredential,
};
